<template>
  <div class="sidebar">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Sidebar"
};
</script>

<style scoped>
.sidebar {
  position: relative;
  min-width: 280px;
  padding: var(--sidbar-padding-y) 0;
  color: var(--dark-color);
}
</style>
